export default __webpack_public_path__ + "static/media/backgroundColor.9359c6d6.png";